import { render, staticRenderFns, recyclableRender, components } from "./creationAuthentication.vue?vue&type=template&id=3bb9a9e9&"
var renderjs
import script from "./creationAuthentication.vue?vue&type=script&lang=js&"
export * from "./creationAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./creationAuthentication.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/creationCenter/creationAuthentication.vue"
export default component.exports